import React from 'react'

const Upload = ({ color = 'black' }: { color?: string }) => {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.5 8V2L10.5 4'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.5 2L14.5 4'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.5 16V17C3.5 19.76 3.5 22 8.5 22H16.5C20.5 22 21.5 19.76 21.5 17V16C21.5 13.79 21.5 12 17.5 12C16.5 12 16.22 12.21 15.7 12.6L14.68 13.68C13.5 14.94 11.5 14.94 10.31 13.68L9.3 12.6C8.78 12.21 8.5 12 7.5 12C3.5 12 3.5 13.79 3.5 16Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.5 12V10C5.5 7.99004 5.5 6.33004 8.5 6.04004'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.5 12V10C19.5 7.99004 19.5 6.33004 16.5 6.04004'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Upload
